var _a, _b;
/*🤫*/
const fragment = (_a = window.o_util) === null || _a === void 0 ? void 0 : _a.fragment;
const core = (_b = window.o_util) === null || _b === void 0 ? void 0 : _b.core;

/*🤫*/
class Hashtracking {
    /*🤫
🤫
🤫
🤫
🤫
🤫*/
    /*🤫*/
    sendData(dataContainer, nonHidden) {
        if (nonHidden) {
            /*🤫*/
            dataContainer = core.extend(dataContainer, {
                ns_type: "",
            });
        }
        /*🤫*/
        window.o_tracking.bct.sendMergeToTrackingServer(dataContainer);
    }
    /*🤫
🤫
🤫*/
    hashTrack() {
        if (this.alreadyTracked) {
            return;
        }
        this.alreadyTracked = true;
        const domList = document.querySelectorAll(".js_tracking");
        const track = core.toArray(domList).some((element) => {
            return element.hasAttribute("data-track");
        });
        if (track) {
            const trackingHash = fragment.get("t");
            /*🤫*/
            if (trackingHash) {
                try {
                    const t = JSON.parse(trackingHash);
                    /*🤫*/
                    if (t) {
                        this.sendData(t);
                        const urlWithoutTinHash = fragment.remove("t", window.location.href);
                        /*🤫*/
                        /*🤫*/
                        const { pathname = "", search = "", hash } = new URL(urlWithoutTinHash);
                        /*🤫*/
                        /*🤫*/
                        window.history.replaceState(window.history.state, document.title, `${pathname}${search}${hash === "#" ? "" : hash}`);
                    }
                }
                catch (e) {
                    console.log(e);
                }
            }
        }
    }
}

export { Hashtracking };
